exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-overlay {\n    display: block;\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    /*shoud be lesser than 1000 to aoivd override the popup menu*/\n    z-index: 999;\n    box-sizing: border-box;\n    background: #fafafa;\n    top: 60px;\n    left: 0px;\n    padding-left: 36px;\n    padding-right: 36px;\n}\n\n.search-header {\n    display: inline-block;\n    width: 100%;\n    position: relative;\n}\n\n.search-title {\n    font-size: 28px;\n    letter-spacing: normal;\n    color: #000;\n}\n\n.search-close {\n    position: absolute;\n    right: 24px;\n    cursor: pointer;\n}\n\n.search-parent-override {\n    position: relative !important;\n}\n\n.search-spinner {\n    top: 50%;\n    left: 50%;\n    position: absolute;\n}\n\n.grid-header-wrapper {\n    text-align: right;\n}\n\n.grid-filter {\n    position: relative;\n    top: 8px;\n    margin: 0px auto 0px auto;\n}\n\n.search-header a:hover {\n    text-decoration: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/base/global-search/search-result.component.css
// module id = 811
// module chunks = 0